import React, { useEffect, useState } from 'react';
import AmbassadorHeader from '../../components/common/AmbassadorHeader';
import Logo from '../../components/common/Logo';
import SidebarMenu from '../../components/ambassador/SidebarMenu';
import { useNavigate, useLocation } from 'react-router-dom';
import swal from 'sweetalert';
import { getAmbassadorDetail} from '../../actions/AmbassadorActions';
import ViewQr from '../../components/ambassador/ViewQr';
import ReferBanner from '../../assets/images/refer-banner.png'
import MobileReferBanner from '../../assets/images/mob-ref-banner.png'
import InMobileSideMenu from '../../components/ambassador/InMobileSideMenu';


const ViewQrCode = (props) => {
   const navigate = useNavigate();
   const [profileDetail, setProfileDetail] = useState({});
  

      useEffect(async() => {
         sessionStorage.getItem("ambDetail")
         ? navigate("/ambassador/view-qr-code")
         : navigate("/ambassador/login");
   
         await getAmbassadorDetail()
         .then((res) => {
            setProfileDetail(res.data)
         })
   
      },[])
   return (
      <>

         <div className='mainAmb_wrapper'>
            {/* Sidebar */}
            <div className={`sidebar_contain`}>
       
               <Logo alt="Logo"/>
               <div className='sidebar_menu_contains'>
                  <SidebarMenu detail={profileDetail}/>
               </div>
         
            </div>

         <div className='mobile_sideMenuWrap d-block d-lg-none'>
            <InMobileSideMenu detail={profileDetail}/>
         </div>

            <div className='main_contentAmb'>
               {/* Header */}
               <div className='headerAmb_contain'>
                  <AmbassadorHeader detail={profileDetail}/>
               </div>
               <div className='amb_content'>
                  <div className='container'>
                     <div className='row  mt-3'>
                        <div className='col-lg-12'>
                           <h2 className='h5 fw-bold'>View QR Code</h2>
                        </div>
                     </div>
                     <div className='row  mt-3'>
                        <div className='col-lg-12'>
                           <div className='card mb-5 shadow-sm'>
                              <div className='card-header p-0 banner_contentWrap'>
                                 <img src={ReferBanner} className="img-fluid d-none d-md-block" alt="Refer Friend"/>
                                 <img src={MobileReferBanner} className="img-fluid d-block d-md-none" alt="Refer Friend"/>

                                 <h2>Refer to Students</h2>
                                 <p>You can refer multiple friends from different countries</p>
                              </div>
                              <div className='card-body pt-5 py-5 px-4'>
                                 <div className='row'>
                                    <div className='col-lg-12'>
                                       <ViewQr />
                                    </div>

                                 

                                 </div>


                              </div>
                           </div>
                        </div>
                     </div>
                  </div>

               </div>

            </div>


         </div>


      </>
   );
}

export default ViewQrCode;